import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { CalendarIcon } from '@WebComponents/svgs/icons/CalendarIcon';
import { useEventLogging } from '../../../../../../models/Logging';
import { Button } from '../../../../../components-v2/Button';
import { ROUTES } from '../../../../../constants/routes';
import { AgentRow, AgentRowIcon } from '../../AgentRow';
import { styleSheet } from '../../styles';
import { MEETING_PREP_TELEMETRY_CATEGORY } from './DashboardMeetingPrepRow';
import { nextDeliveryLabel } from './helpers';

export const DashboardMeetingPrepQuietRow: FC<{
	template: Api.MeetingPrepTemplate;
	timeZone: string;
}> = ({ template, timeZone }) => {
	const history = useHistory();
	const { logEvent } = useEventLogging(MEETING_PREP_TELEMETRY_CATEGORY);

	return (
		<AgentRow
			icon={
				<AgentRowIcon>
					<CalendarIcon />
				</AgentRowIcon>
			}
			title={
				<>
					No meetings prepped for today
					<span className={css(styleSheet.rowTitleMeta)}>Meeting Prep Assistant</span>
				</>
			}
			detail={`Next briefs arrive ${nextDeliveryLabel(template, timeZone)}.`}
			action={
				<Button
					size='sm'
					variant='secondary'
					onClick={() => {
						logEvent('ViewBriefsClicked', { from: 'quietRow' });
						history.push(ROUTES.meetingPrep.briefs);
					}}
				>
					View past briefs
				</Button>
			}
		/>
	);
};
